import ControlModule from 'scripts/poppet/control-module';
import template      from './controlAlarmSwitchView.jst.html';
import { Vue }       from 'vue/defavue';
import { T }         from 'defa-object';

/**
 * defa.views.ControlAlarmSwitchView
 * A control module alarm switch
 * @version 1.3.0
 */

const intrusionSwitchOptions = [
	{ value: 'ON', title: T.tc('ControlGeneral', 'On'), titleContext: 'ControlGeneral' },
	{ value: 'OFF', title:T.tc('ControlGeneral', 'Off'), titleContext: 'ControlGeneral' },
	];

const ControlAlarmSwitchView = ControlModule.extend( {
	template : template,
	expandedNavState  : 'unit:control:switches',
	compressedNavState: 'unit:control:overview',

	className() {
		return this._getClassName( 'control-switches' );
	},

	onDomRefresh() {
		let self   = this;

		 new Vue( {
			el: '#alarm-slider',
			bb() {
				return {
					model: self.model,
				};
			},
			data() {
				return {
					intrusionSwitchValue: 'ON',
					intrusionSwitchOptions,
				};
			},
			methods : {
				save(newValue, attributeName) {
					let data = {};
					data[attributeName]= 'ON' === newValue;
					self.save( data )
				},
			},
			
			 watch: {
				 'model.intrusionSwitch': function (newAttribute){
					 this.intrusionSwitchValue = newAttribute ? 'ON' : 'OFF';
				 }
			 },
			
			 created() {
				 this.intrusionSwitchValue = this.model.intrusionSwitch ? 'ON' : 'OFF';
			 }
		});
	},
	
	save: function(attributes) {
		let self = this;
		self.model.set('isValidData', false);
		try {
			this.model.save(attributes, {
				isSaving: true,
				patch: true,
				success: function () {
					console.log( Object.keys(attributes)[0] +' was succesfully saved!' );
				},
				error  : function (model, response) {
					console.error( Object.keys(attributes)[0] + ' failed saving with error: ' + response.responseJSON.message );
				}
			});
		} catch ( err ) {
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	}

} );

export default ControlAlarmSwitchView;
